import {getMethod, putMethod} from '~/api'

async function get(personId) {
    return await getMethod(`/api/notificationSettings/person/${personId}`)
}

async function put(personId, request) {
    return await putMethod(`/api/notificationSettings/person/${personId}`, request)
}

export {get, put}
